import React, { Component } from 'react'
import { connect } from 'react-redux'
import { NavLink, withRouter } from 'react-router-dom'
import InvoiceRoute from './InvoiceRoute'
import InvoiceSearch from './InvoiceSearch'
import { InvoiceService } from '../../../services'
import { startFetch, endFetch } from '../../../actions/generalActions'
import { prefix } from '../../../i18n'
import ToastService from '../shared/Toast/ToastService'

const tInvoice = prefix('invoice')

class ValidatorContainer extends Component {
  state = {
    toValidateInvoices: [],
    validatedInvoices: [],
    toValidatePage: 1,
    toValidateTotalPages: null,
    validatedPage: 1,
    validatedTotalPages: null,
  }

  componentDidMount() {
    const { campaign } = this.props
    this.fetchToValidate(campaign, 1)
    this.fetchValidated(campaign, 1)
  }

  fetchToValidate = (campaign, page) => {
    const { client } = this.props
    this.props.startFetch()
    // Invoices waiting for validator approval → index_waiting_approval endpoint.
    InvoiceService.getWaitingApprovalInvoices({ clientId: client.slug, campaignId: campaign.slug, page })
      .then(response => {
        const { invoices, total_pages } = response.data
        this.setState({ toValidateInvoices: invoices, toValidateTotalPages: total_pages, toValidatePage: page })
        this.props.endFetch()
      })
      .catch(() => this.props.endFetch())
  }

  fetchValidated = (campaign, page) => {
    const { client } = this.props
    this.props.startFetch()
    // Already validated invoices → index_verified endpoint.
    InvoiceService.getVerifiedInvoices({ clientId: client.slug, campaignId: campaign.slug, page })
      .then(response => {
        const { invoices, total_pages } = response.data
        this.setState({ validatedInvoices: invoices, validatedTotalPages: total_pages, validatedPage: page })
        this.props.endFetch()
      })
      .catch(() => this.props.endFetch())
  }

  handleValidatorPageUpdate = (path) => ({ selected }) => {
    const { campaign } = this.props
    const page = selected + 1
    if (path.includes('to_validate')) this.fetchToValidate(campaign, page)
    if (path.includes('validated'))   this.fetchValidated(campaign, page)
  }

  handleSearchRequest = (filters) => {
    const { campaign, client } = this.props
    this.props.startFetch()
    // Filter through the waiting-approval list (the validator's primary queue).
    InvoiceService.getWaitingApprovalInvoices({
      clientId: client.slug,
      campaignId: campaign.slug,
      filters,
      page: 1,
    })
      .then(response => {
        const { invoices } = response.data
        this.setState({ toValidateInvoices: invoices, validatedInvoices: [] })
        this.props.endFetch()
      })
      .catch(error => {
        this.props.endFetch()
        ToastService.error(error.message || 'Erro ao pesquisar faturas')
      })
  }

  render() {
    const { campaign } = this.props
    const {
      toValidateInvoices, validatedInvoices,
      toValidatePage, toValidateTotalPages,
      validatedPage, validatedTotalPages,
    } = this.state

    const tabs = [
      { label: tInvoice('to-validate'), path: '/invoice/to_validate' },
      { label: tInvoice('validated'), path: '/invoice/validated' },
    ]

    return (
      <div className="invoice-layout">
        <div className="invoice-layout-header">
          <h4 className="invoice-layout-header-title">{tInvoice('title')}</h4>
        </div>

        <nav className="invoice-layout-navigation">
          {tabs.map(tab => (
            <NavLink
              key={tab.path}
              to={tab.path}
              activeClassName="invoice-layout-navigation-item-active"
              className="invoice-layout-navigation-item"
            >
              {tab.label}
            </NavLink>
          ))}
        </nav>

        <InvoiceSearch
          campaign={campaign}
          validator
          onSearchRequest={this.handleSearchRequest}
        />

        <div className="invoice-layout-content">
          <InvoiceRoute
            path="/invoice/to_validate"
            editable={false}
            validatable
            completeTable={false}
            completeForm
            validatorView
            campaign={campaign}
            invoices={toValidateInvoices}
            onPageChange={this.handleValidatorPageUpdate}
            currentPage={toValidatePage - 1}
            totalPages={toValidateTotalPages}
          />
          <InvoiceRoute
            path="/invoice/validated"
            editable={false}
            validatable={false}
            completeTable
            completeForm
            validatorView
            campaign={campaign}
            invoices={validatedInvoices}
            onPageChange={this.handleValidatorPageUpdate}
            currentPage={validatedPage - 1}
            totalPages={validatedTotalPages}
          />
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  client: state.userReducer.client,
})

const mapDispatchToProps = (dispatch) => ({
  startFetch: () => dispatch(startFetch()),
  endFetch: () => dispatch(endFetch()),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ValidatorContainer))
